// extracted by mini-css-extract-plugin
export default {"headerMenu":"menu_headerMenu__6U4RS","ant-menu-title-content":"menu_ant-menu-title-content__8foOJ"};